import ListaPreciosVentaCrud from "./ListaPreciosVentaCrud.vue";
export default ListaPreciosVentaCrud;
